import axios from 'axios';
import { from } from 'rxjs';

const URL = '/report/generate/async';

export const generateReport = (payload) => {
  return from(axios.post(`${URL}`, payload).then(({ data }) => data));
};

export const downloadReport = (path) => {
  return from(axios.post(`/download/report/${path}`));
};

const createElementForAttachment = (url) => {
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadReportAsAttachment = (path) => {
  return createElementForAttachment(`/api/download/report/${path}?download=1&replaceFileName=0`);
};
